import {
    HttpClient,
    HttpEvent,
    HttpHandler,
    HttpHeaders,
    HttpInterceptor,
    HttpParams,
    HttpRequest,
} from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable, catchError, switchMap } from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    keycloak_serveur = environment.keycloak_serveur;
    keycloak_host = environment.keycloak_host;
    keycloak_client_secret = environment.keycloak_client_secret;
    keycloak_client_id = environment.keycloak_client_id;
    token: string;
    expiration: number; // To store the expiration time of the token
    excludeUrls = [
        '/realms/irbeh/protocol/openid-connect/token',
        '9696/api/data',
        '/admin/realms/irbeh/users',
        '9696/api/miniChart/data',
    ];

    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private http: HttpClient
    ) {}

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (this.excludeUrls.some((url) => req.url.includes(url)))
            return next.handle(req);

        // Check if token exists and is not expired
        if (this.token && this.expiration && this.expiration > Date.now()) {
            const authReq = req.clone({
                headers: req.headers.set(
                    'Authorization',
                    `Bearer ${this.token}`
                ),
            });
            return next.handle(authReq);
        } else {
            // If token is expired or doesn't exist, make request to get token
            const headers = new HttpHeaders().set(
                'Content-Type',
                'application/x-www-form-urlencoded;'
            );
            const body = new HttpParams()
                .set('grant_type', 'password')
                .set('client_secret', this.keycloak_client_secret)
                .set('client_id', this.keycloak_client_id)
                .set('password', '123456')
                .set('username', 'adminbackend');

            return this.http
                .post(
                    this.keycloak_host +
                        '/realms/irbeh/protocol/openid-connect/token',
                    body,
                    { headers: headers }
                )
                .pipe(
                    switchMap((response: any) => {
                        const token = response['access_token'];
                        const expiresIn = response['expires_in'];
                        this.expiration = Date.now() + expiresIn * 1000;
                        this.token = token;

                        return next.handle(
                            req.clone({
                                headers: req.headers.set(
                                    'Authorization',
                                    `Bearer ${token}`
                                ),
                            })
                        );
                    }),
                    catchError((error) => {
                        console.log('Error:', error);
                        return next.handle(req);
                    })
                );
        }
    }
}
